import { CustomButton } from '@/components';
import { Flex, Image } from 'antd';
import { Link } from 'react-router-dom';
import aiNoData from '../../../assets/images/no-ai-conversation.png';
import { AIHistoryEmptyStateProps } from '../type';

const AIHistoryEmptyState = ({
  isEmptyList,
  isLoading,
  hasActiveSearchOrFilters = false,
}: AIHistoryEmptyStateProps) => {
  return (
    <div className='empty-state-wrapper flex-center x y'>
      <Flex gap={12} justify='center' align='center' vertical>
        <Image
          src={aiNoData}
          className='ai-history-empty-img'
          preview={false}
        />
        {isLoading ? (
          <p className='zl-heading-24'>AI communications loading...</p>
        ) : isEmptyList && hasActiveSearchOrFilters ? (
          <>
            <p className='zl-heading-24'>No Data Found</p>
            <p className='zl-para-14 color-5e text-center ai-history-empty-text'>
              No AI conversations match your search or filters. Try a different
              search or clear the filters.
            </p>
          </>
        ) : isEmptyList ? (
          <>
            <p className='zl-heading-24'>No AI conversations yet</p>
            <p className='zl-para-14 color-5e text-center ai-history-empty-text'>
              Once your AI assistant starts handling calls and emails, you’ll be
              able to track all these logs and relevant KPIs here
            </p>
            <Link to={'/settings/ai-controls'}>
              <CustomButton
                text='Enable AI here'
                fontSize='14px'
                fontWeight='600'
                lineHeight='20px'
                bgColor='var(--light-gray)'
                color='var(--text-primary)'
                height='48px'
                width='130px'
                borderRadius='100px'
                boxShadow='none'
              />
            </Link>
          </>
        ) : null}
      </Flex>
    </div>
  );
};

export default AIHistoryEmptyState;
